import { API } from '@Providers';

interface AddCustomAdditionalFeePayload {
  animal_id: string;
  amount: number;
  description: string;
}

export default async function (payload: AddCustomAdditionalFeePayload) {
  const endpoint = '/api/shelter/cart/add-custom-additional-fee';

  return API({ endpoint, method: 'post', payload });
}
